export interface IBindingRule {
    constraintId: string;
    action: BindingType;
}

export enum BindingType {
    Visibility = 0,
    Enabled = 1,
    Calculation = 2,
    Label = 3,
    Tooltip = 4,
    VisibilityOrEmpty = 5,
}
